;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('ComputingService', ComputingService)

  ComputingService.$inject = [
    // Angular
    '$filter'
    // Libs
    // Managers
    // Services
    // Const
    // Resolved

  ]

  function ComputingService (
    // Angular
    $filter
    // Libs
    // Managers
    // Services
    // Const
    // Resolved

  ) {
    var self = this

    _.extend(self, {
      // Methods
      getVATs: getVATs,
      getCreditNoteVATs: getCreditNoteVATs,
      getDiscounts: getDiscounts,
      getDiscountAmount: getDiscountAmount,
      getDiscountValue: getDiscountValue,
      getDiscountedTotal: getDiscountedTotal,
      getTotalDiscount: getTotalDiscount,
      containsDiscount: containsDiscount,
      getObjectDiscountedTotal: getObjectDiscountedTotal,
      getTotal: getTotal,
      getFullTotal: getFullTotal,
      getCreditNoteFullTotal: getCreditNoteFullTotal,
      getGlobalDiscountValue: getGlobalDiscountValue
    })

    function getFullTotal (lines, vats, invoice) {
      return (getObjectDiscountedTotal(lines) - getGlobalDiscountValue(invoice)) + _.reduce(vats, function (acc, vat) {
        return Math.round(acc + vat.amount)
      }, 0)
    }

    function getCreditNoteFullTotal (lines, vats) {
      return getTotal(lines) + _.reduce(vats, function (acc, vat) {
        return Math.round(acc + vat.amount)
      }, 0)
    }

    function getObjectDiscountedTotal (lines, element) {
      if (!element) {
        return _.reduce(lines,
          function (acc, line) {
            if (line.type === 'label') return acc
            return Math.round(acc + (line.total - (line.discountAmount || 0)))
          }, 0)
      }
      return _.reduce(lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          return Math.round(acc + (line.total - (line.discountAmount || 0)))
        }, 0) - getGlobalDiscountValue(element)
    }

    function getTotal (lines) {
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc
        return Math.round(acc + line.total)
      }, 0)
    }

    function containsDiscount (object) {
      if (!object.hasOwnProperty('lines') || !object.lines.length) { return false }
      return !!_.filter(object.lines, function (elt) {
        return elt.discount
      }).length
    }

    function getTotalDiscount (discounts) {
      return _.reduce(discounts, function (acc, discount) {
        acc += discount.value
        return acc
      }, 0)
    }

    function getVATs (lines, element) {
      if (_.get(element, 'hasSingleVAT') && element.hasSingleVAT() && _.get(element, 'lines.length') && _.filter(element.lines, function (l) { return l.type !== 'label' }).length) {
        var vat = _.filter(lines, function (l) { return l.type !== 'label' })[0].VAT
        return [{vat: vat, amount: (getObjectDiscountedTotal(lines) - getGlobalDiscountValue(element)) * (vat / 100)}]
      }
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc
        var vat = line.VAT
        var vatTotal = _.find(acc, { vat: vat })
        if (!vatTotal) {
          vatTotal = { vat: vat, amount: 0 }
          acc.push(vatTotal)
        }
        vatTotal.amount += Math.round((line.total - (line.discountAmount || 0)) * line.VAT / 100)
        return acc
      }, [])
    }

    function getCreditNoteVATs (lines) {
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc
        var vat = line.VAT
        var vatTotal = _.find(acc, { vat: vat })
        if (!vatTotal) {
          vatTotal = { vat: vat, amount: 0 }
          acc.push(vatTotal)
        }
        vatTotal.amount += Math.round(line.total * line.VAT / 100)
        return acc
      }, [])
    }

    function getDiscounts (lines) {
      return _.compact(_.map(lines, function (line) {
        if (line.type === 'label' || !line.discount) return
        return {
          amount: getDiscountAmount(line),
          value: getDiscountValue(line),
          type: _.get(line.discount, 'type')
        }
      }))
    }

    function getDiscountedTotal (line) {
      if (!line.discount) {
        return
      }
      return Math.round(line.total - line.discountAmount)
    }

    function getDiscountAmount (line) {
      if (!line.discount) { return }
      if (line.discount.type === 'percentage') {
        return '-' + line.discount.amount + ' %'
      }
      var numeral = $filter('numeral')
      return '-' + numeral(line.discount.amount, '0,0[.]00 $')
    }

    function getGlobalDiscountValue (element) {
      if (!_.get(element, 'globalDiscount.amount')) {
        return 0
      }
      switch (_.get(element, 'globalDiscount.type')) {
        case 'percentage':
          return getObjectDiscountedTotal(_.get(element, 'lines', [])) * (element.globalDiscount.amount / 100)
        case 'fixed':
          return _.get(element, 'globalDiscount.amount', 0)
      }
    }

    function getDiscountValue (line) {
      if (!line.discount) { return }
      if (line.discount.type === 'fixed') { return _.get(line.discount, 'amount', 0) }
      return Math.round(line.total * (_.get(line.discount, 'amount', 0) / 100))
    }
  }
})(window.angular, window._, window.moment)
